import React from 'react';
import type { MessageDescriptor } from 'react-intl';
import { defineMessages, FormattedMessage } from 'react-intl';

import { handleError } from '../../utils/common-utils';

const errorMessages = defineMessages({
  serverError: { defaultMessage: `Error {errorCode}`, id: '2wdU2v' },
  clientError: { defaultMessage: `An error has occurred on your device`, id: 'iPQ/MD' },
  genericError: {
    defaultMessage: 'An error occurred while loading GraphComment',
    id: 'fnkH+h',
  },
  retry: { defaultMessage: 'Retry', id: '62nsdy' },
});

export const ErrorLayout: React.FC<{ error: any }> = ({ error }) => {
  const errorCode: string | undefined = error?.statusCode?.toString();
  const errorMsg: MessageDescriptor | string = error?.message;
  handleError(error);
  return (
    <>
      <div className="show-more" data-ignore-caching>
        <FormattedMessage
          {...(errorCode ? errorMessages.serverError : errorMessages.clientError)}
          values={{ errorCode }}
        />
      </div>
      <div className="oops" data-ignore-caching>
        <i className="icon-bug" />
        <p>
          <b>
            {typeof errorMsg === 'string' ? (
              errorMsg
            ) : (
              <FormattedMessage {...(errorMsg || errorMessages.genericError)} />
            )}
          </b>
        </p>
        <button type="button" onClick={() => window.location.reload()}>
          <i className="icon-retry" />
          <FormattedMessage {...errorMessages.retry} />
        </button>
      </div>
    </>
  );
};
